import React from 'react'
import { AppBar, Toolbar, IconButton, Button, Typography } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  navAction: {
    marginRight: theme.spacing(1)
  }
}))

const AppBarComponent = (props) => {
  const classes = useStyles();

  const { active, onToggle } = props;

  return (
    <div>
      <AppBar position='static' >
        <Toolbar>
          <IconButton
            edge='start' 
            color='inherit'
            onClick={onToggle('home')}
          >
            <HomeIcon />
          </IconButton>
          <Typography className={classes.title}>{active}</Typography>
{/*          <Button
            disabled={active === 'form' ? true : false}
            className={classes.navAction}
            variant='outlined'
            color='inherit'
            onClick={onToggle('form')}
          >
            Add/Edit
          </Button>
          <Button
            disabled={active === 'display' ? true : false}
            className={classes.navAction}
            variant='outlined'
            color='inherit'
            onClick={onToggle('display')}
          >
            List All
          </Button>
          <Button
            disabled={active === 'todos' ? true : false}
            className={classes.navAction}
            variant='outlined'
            color='inherit'
            onClick={onToggle('todos')}
          >
            Todos
        </Button>
*/}
        </Toolbar>
      </AppBar>
    </div>
  )
}

export default AppBarComponent

